module.exports = __webpack_public_path__ + "assets/img/puzzle@1,5x.88b1725f.svg";